exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sample-invoice.md-disabled[data-v-7bc5e5cc]::after {\n  border-bottom: 0 !important;\n}\n", ""]);

// exports
